import React, { useContext, useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import io from "socket.io-client";
import useRefreshToken from "../../../context/useRefreshToken";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import MatchCard from "../../../components/MatchCard/MatchCard";

import { ToastContainer } from "react-toastify";
import Loader from "../../../components/Loader";
import { useSocket } from "../../../context/SocketContext";
const AppliedMatches = () => {
  const { authenticated, setAuthenticated } = useAuth();

  const axiosPrivate = useAxiosPrivate();
  const navgate = useNavigate();
  const refresh = useRefreshToken();
  const { socket } = useSocket(); // Backend URL
  const [loading, setloading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated?.user?.isVerified !== true) {
      navigate("/verifyEmail");
    }

    let isMounted = true;
    const controller = new AbortController();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // };
  }, []);

  const [listings, setListings] = useState([]);

  useEffect(() => {
    setloading(true);

    const fetchListings = async () => {
      await axiosPrivate
        .get("/listings/MyMatches", { withCredentials: true })
        .then((res) => {
          console.log(res.data);
          setListings(res.data);
          setloading(false);
        });
    };
    // Fetch initial listings

    fetchListings();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  const handleReset = () => {
    // Reset to default values
    reset({
      game: "PUBG MOBILE",
      // or any default value you want to set
    });
  };

  return (
    <>
      <ToastContainer />
      <div>
        <div></div>
        <form
          className="mx-5"
          onSubmit={handleSubmit(async (data) => {
            setloading(true);

            console.log(data);
            await axiosPrivate
              .get("/listings/myMatches", {
                withCredentials: true,
                params: {
                  oldMatches: data.oldMatches,
                  matchId: data.matchId,
                },
              })
              .then((res) => {
                console.log(res.data);
                setListings(res.data);
                setloading(false);

                // setListings(res.data);
              });
          })}
        >
          <div className="grid md:grid-cols-7 grid-rows-1 gap-4 myfilterstep">
            <div>
              <select
                {...register("oldMatches", {
                  required: "This field is required.",
                })}
                className={`block appearance-none  w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-gray-700 py-3 px-4 pr-8 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                defaultValue="Select Country"
              >
                <option value={false} default>
                  Today Matches
                </option>
                <option value={true} default>
                  Old Matches
                </option>
              </select>
            </div>

            <div>
              <input
                {...register("matchId", {})}
                className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                  errors.Country?.message ? "border-red-700" : null
                } text-black py-3 px-1 pr-4 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                id="grid-state-country"
                placeholder="Search Match by Id"
              />
            </div>
            <div className="">
              <img
                src="https://api.iconify.design/hugeicons:system-update-02.svg?color=%23ffffff"
                className="w-[30px] h-[30px] "
                style={{ cursor: "pointer" }}
                alt="refresh filter"
                onClick={async () => {
                  await axiosPrivate
                    .get("/listings/MyMatches", { withCredentials: true })
                    .then((res) => {
                      console.log(res.data);
                      setListings(res.data);
                      handleReset();
                    });
                }}
              />
            </div>
            <div className="flex justify-center">
              <div>
                <button
                  type="submit"
                  className=" tracking-wide  font-semibold bg-purple-700 text-white w-full py-3 px-10 rounded-lg hover:bg-purple-900 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </form>
        <div className="m-5 flex justify-center items-center totalMatchesstep">
          {loading ? (
            <>
              <Loader />
            </>
          ) : listings.length > 0 ? (
            <>
              <div className="grid  md:grid-cols-3 grid-rows-1 gap-4 ">
                {listings.map((listing, index) => {
                  return (
                    <div key={listing?._id} className="singleMatchDetails">
                      <MatchCard key={listing?._id} listing={listing} />
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <div className="w-full flex m-2 justify-center rounded-xl items-center h-[400px] bg-black bg-opacity-50">
                <p className="text-gray-400 font-bold">No Matches Found.</p>
              </div>
            </>
          )}
        </div>

        {/* <button onClick={refresh}>refresh</button> */}
      </div>
    </>
  );
};

export default AppliedMatches;
